import Navigationbar from './component/Navigationbar';
import Footer from './component/Footer';

import './App.css';



function App() {
  return (
    <>
    <Navigationbar />
    <Footer />
    
    </>
  );
}

export default App;
